'use client';

import { useFormContext } from 'react-hook-form';

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import type { SaleApplicationData } from '@/features/original-sale';
import { cn } from '@/lib/utils';

export const SalePersonalFieldsStepOne = () => {
  const { control } = useFormContext<SaleApplicationData>();

  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="name"
        render={({ field, fieldState }) => (
          <FormItem>
            <FormLabel className={cn('font-normal', !fieldState.error && 'text-[#888C91]')}>
              Имя<span>*</span>
            </FormLabel>
            <FormControl>
              <Input className="h-10 font-medium" placeholder="Введите имя" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="phone"
        render={({ field, fieldState }) => (
          <FormItem>
            <FormLabel className={cn('font-normal', !fieldState.error && 'text-[#888C91]')}>
              Номер телефона<span>*</span>
            </FormLabel>
            <FormControl>
              <Input className="h-10 font-medium" placeholder="Введите номер телефона" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="contactLink"
        render={({ field, fieldState }) => (
          <FormItem>
            <FormLabel className={cn('font-normal', !fieldState.error && 'text-[#888C91]')}>
              Ссылка на TG/VK для связи
              <span>*</span>
            </FormLabel>
            <FormControl>
              <Input className="h-10 font-medium" placeholder="Введите URL-адрес" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="profileLink"
        render={({ field, fieldState }) => (
          <FormItem>
            <FormLabel className={cn('font-normal', !fieldState.error && 'text-[#888C91]')}>
              Ссылка на ваш наиболее популярный профиль на других литературных порталах
            </FormLabel>
            <FormControl>
              <Input className="h-10 font-medium" placeholder="Введите URL-адрес" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
